import UAParser from 'ua-parser-js';
import PerfectScrollbar from 'perfect-scrollbar';

export default {
  computed: {
    isCmsPreview() {
      return this.$route.name == 'CMSPreviewMaterial';
    }
  },
  data() {
    return {
      isSafariBrowser: new UAParser().getBrowser().name.includes('Safari')
    }
  },
  methods: {
    setCMSTableScrollable() {
      if (this.isIpadDevice || this.isMobileWidth) {
        const tableParentClass = ['basic-table-container', 'evaluation-table-container'];
        for (const className of tableParentClass) {
          this.addNewPerfectScrollbar(className)
        }
      }
    },
    addNewPerfectScrollbar(tableParentClass) {
      const table = document.querySelectorAll(`.${tableParentClass}`);
        if (table) {
          table.forEach((cmsTable, ndx) => {
            cmsTable.classList.add(`${tableParentClass}-${ndx}`);
            // Double check if it's really added
            if (document.getElementsByClassName(`${tableParentClass}-${ndx}`)) {
              this.cmsTableScrolls = [...this.cmsTableScrolls, new PerfectScrollbar(`.${tableParentClass}-${ndx}`)];
            }
            cmsTable.style.width = '100%';
          })
        }
    }
  }
}
